import React, { useState } from 'react';
import { CATEGORIES, COURSES } from '../data/courses';
import './ClassesSection.css';

// Course list comes from the shared data file (also used by the Programs page)
const classesData = COURSES;

const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'standard', label: 'Standard' },
  { key: 'mastery', label: 'Mastery' },
  { key: 'robotics', label: 'Robotics' },
];

const PREVIEW_COUNT = 8; // rows shown on phones before "See all"

const ClassesSection = () => {
  const [filter, setFilter] = useState('all');
  const [showAll, setShowAll] = useState(false);

  const visible = filter === 'all' ? classesData : classesData.filter((c) => c.category === filter);
  const count = (key) => (key === 'all' ? classesData.length : classesData.filter((c) => c.category === key).length);
  // On phones the full list is long, so "All" starts collapsed there (CSS hides rows after 8)
  const collapsible = filter === 'all' && visible.length > PREVIEW_COUNT;

  return (
    <section className="rmc" id="courses" aria-labelledby="rmc-title">
      <div className="rmc-inner">
        <header className="rmc-header">
          <span className="rmc-eyebrow">{classesData.length} courses</span>
          <h2 id="rmc-title" className="rmc-title">
            Pick a path, from first code to mastery
          </h2>
        </header>

        <div className="rmc-filters" role="group" aria-label="Filter courses by package">
          {FILTERS.map((f) => {
            const cat = CATEGORIES[f.key];
            return (
              <button
                key={f.key}
                type="button"
                aria-pressed={filter === f.key}
                className={`rmc-filter ${filter === f.key ? 'is-active' : ''}`}
                onClick={() => setFilter(f.key)}
              >
                {cat && <span className="rmc-dot" style={{ background: cat.color }} aria-hidden="true" />}
                {f.label}
                <span className="rmc-count">{count(f.key)}</span>
              </button>
            );
          })}
        </div>

        <ul className={`rmc-list ${collapsible && !showAll ? 'is-collapsed' : ''}`}>
          {visible.map((c) => {
            const cat = CATEGORIES[c.category];
            return (
              <li key={c.title} className={`rmc-row ${c.isNew ? 'is-new' : ''}`}>
                <span
                  className="rmc-row-dot"
                  style={{ background: cat.color }}
                  title={`${cat.label} package`}
                  aria-label={`${cat.label} package`}
                />
                <div className="rmc-row-main">
                  <span className="rmc-row-name">
                    {c.title}
                    {c.isNew && <span className="rmc-new">NEW</span>}
                  </span>
                  <span className="rmc-row-text">{c.text}</span>
                </div>
                <span className="rmc-row-age">Ages {c.age}</span>
                <span className="rmc-row-sessions">{c.sessions} sessions</span>
              </li>
            );
          })}
        </ul>

        {collapsible && (
          <button type="button" className="rmc-more" onClick={() => setShowAll(!showAll)} aria-expanded={showAll}>
            {showAll ? 'Show fewer courses' : `See all ${visible.length} courses`}
          </button>
        )}
      </div>
    </section>
  );
};

export default ClassesSection;